import * as React from 'react';
import { observer } from 'mobx-react-lite';
import { FocusTrapZone } from '@fluentui/react/lib/FocusTrapZone';
import type { IFocusZoneProps } from '@fluentui/react/lib/FocusZone';

export default observer(function DueDateMenuPickerWrapper(props: IFocusZoneProps) {
    const { className, children } = props;
    return (
        <FocusTrapZone className={className} isClickableOutsideFocusTrap={true}>
            {children}
        </FocusTrapZone>
    );
});
